"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.objTitle = exports.defaultObj = void 0;
var defaultObj = exports.defaultObj = {
  attrs: [],
  ////数据渲染用
  id: null,
  merchantType: 10,
  merId: 9,
  categoryId: 0,
  categoryName: "房间",
  cateId: 71,
  cateName: "单间",
  image: "",
  flatPattern: "",
  videoLink: "",
  sort: 1,
  rank: 1,
  price: 0,
  remark: "",
  intro: "",
  keyword: "",
  unitName: "间",
  area: 0,
  bedType: "",
  window: "有窗",
  wifi: "有wifi",
  floor: "",
  breakfast: "有早餐",
  roomTypeName: "",
  quantity: 0,
  duration: "1晚",
  cancelRuleType: 1,
  cancelRuleContent: "",
  cancelRuleTypeDesc: "",
  brandId: 0,
  purchastNotice: '',
  sliderImages: [],
  sliderImage: '',
  // 限购规则与退换货规则
  limitBuyRuleIds: [],
  // 限购规则ID
  productReturnRuleIds: [],
  // 退货规则ID
  ext: {
    limitBuyContent: '',
    numberIn: '',
    reservationContent: '',
    productReturnContent: '',
    originPrice: ''
  },
  smokingCondition: '',
  name: '',
  cateIds: [],
  // 商品分类id
  isShow: false,
  tempId: '',
  header: [],
  selectRule: '',
  content: '',
  specType: false,
  couponIds: [],
  coupons: [],
  guaranteeIds: '',
  guaranteeIdsList: null,
  type: 0,
  // 商品类型
  isAutoSubmitAudit: false,
  //是否自动提审
  isAutoUp: false,
  //是否自动上架
  deliveryMethodList: ['1'],
  deliveryMethod: '',
  systemFormId: null,
  refundSwitch: true
};
var objTitle = exports.objTitle = {
  price: {
    title: '售价（元）'
  },
  vipPrice: {
    title: '会员价（元）'
  },
  cost: {
    title: '成本价（元）'
  },
  otPrice: {
    title: '划线价（元）'
  },
  stock: {
    title: '库存'
  },
  barCode: {
    title: '商品编码'
  },
  itemNumber: {
    title: '商品条码'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  },
  brokerage: {
    title: '一级返佣(%)'
  },
  brokerageTwo: {
    title: '二级返佣(%)'
  }
};